import { render, staticRenderFns } from "./smsRecord.vue?vue&type=template&id=f205b1a2"
import script from "./smsRecord.vue?vue&type=script&lang=js"
export * from "./smsRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports